var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Generic',{attrs:{"title":"Consulta de protocolos","protocolos":this.protocol.rows,"name":"Protocolo"}})}
var staticRenderFns = []

export { render, staticRenderFns }